import {
  SiVisa,
  SiMastercard,
  SiAmericanexpress,
  SiKlarna,
  SiApplepay,
  SiGooglepay,
} from 'react-icons/si';

const methods = [
  { Icon: SiVisa, label: 'Visa' },
  { Icon: SiMastercard, label: 'Mastercard' },
  { Icon: SiAmericanexpress, label: 'American Express' },
  { Icon: SiKlarna, label: 'Klarna' },
  { Icon: SiApplepay, label: 'Apple Pay' },
  { Icon: SiGooglepay, label: 'Google Pay' },
];

export const PaymentMethods = ({ className = '' }) => (
  <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="payment-methods">
    {methods.map(({ Icon, label }) => (
      <span
        key={label}
        title={label}
        aria-label={label}
        className="inline-flex items-center justify-center h-7 w-11 rounded-md bg-ivory text-ink"
      >
        <Icon className="h-4 w-auto" />
      </span>
    ))}
  </div>
);
